import { CategoryDescriptionsFromDocument, InitEmailPreferencesPanel } from 'smg/email-preferences-page';
InitEmailPreferencesPanel({ mode: 'link', categoryDescriptions: CategoryDescriptionsFromDocument() });
